import { lazy } from 'react';
import { DashboardLayout } from '../../../app/components';
import { routingPath } from '../../../app/routes';

const Cnab444Page = lazy(() =>
  import('../pages/Cnab444').then((m) => ({ default: m.Cnab444Page })),
);
const CessionsPage = lazy(() =>
  import('../pages').then((m) => ({ default: m.CessionsPage })),
);
const CessionsDetailsPage = lazy(() =>
  import('../pages/Cessions/components').then((m) => ({
    default: m.CessionsDetailsPage,
  })),
);

const CessionRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      {
        path: routingPath.cession.cnab444,
        element: <Cnab444Page />,
      },
      {
        path: routingPath.cession.cessions,
        element: <CessionsPage />,
      },
      {
        path: routingPath.cession.cessionsDetails,
        element: <CessionsDetailsPage />,
      },
    ],
  };
};

export default CessionRoutes;
